import React from "react"
import PropTypes from "prop-types"
import { formatCurrency, formatNumber } from "../helpers"

const CargosTab = ({ data }) => {
  const cargos = data?.cargos || []

  if (cargos.length === 0) {
    return (
      <div style={{ padding: 60, textAlign: "center", color: "#64748b" }}>
        <i className="mdi mdi-tag-off-outline" style={{ fontSize: 48, color: "#cbd5e1" }} />
        <div className="mt-2">Sin cargos ni propinas registradas en esta factura.</div>
      </div>
    )
  }

  const total = cargos.reduce((s, c) => s + (Number(c.valor || c.total) || 0), 0)

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 style={{ margin: 0, color: "#0f172a", fontWeight: 600 }}>
          <i className="mdi mdi-tag-text-outline me-2 text-primary" />
          Cargos y propinas ({formatNumber(cargos.length)})
        </h6>
        <span style={{ fontSize: 13, color: "#475569" }}>
          Total: <strong style={{ color: "#0f172a" }}>{formatCurrency(total)}</strong>
        </span>
      </div>

      <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", background: "#fff" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#f1f5f9" }}>
              <th style={{ padding: "10px 12px", textAlign: "left", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Razón / descripción</th>
              <th style={{ padding: "10px 12px", textAlign: "center", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Código</th>
              <th style={{ padding: "10px 12px", textAlign: "right", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Porcentaje</th>
              <th style={{ padding: "10px 12px", textAlign: "right", fontSize: 11, color: "#475569", textTransform: "uppercase", fontWeight: 600 }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {cargos.map((c, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "10px 12px", color: "#0f172a", fontWeight: 500 }}>
                  {c.razon || c.descripcion || c.descripciondescuento || "—"}
                </td>
                <td style={{
                  padding: "10px 12px", textAlign: "center", color: "#475569",
                  fontFamily: "ui-monospace, SFMono-Regular, monospace", fontSize: 12,
                }}>
                  {c.codcargo || c.codigo || "—"}
                </td>
                <td style={{ padding: "10px 12px", textAlign: "right", color: "#475569" }}>
                  {c.porcentaje != null ? `${Number(c.porcentaje).toFixed(2)}%` : "—"}
                </td>
                <td style={{ padding: "10px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700 }}>
                  {formatCurrency(c.valor || c.total)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}>
              <td colSpan={3} style={{ padding: "10px 12px", fontWeight: 700, color: "#0f172a", textAlign: "right" }}>
                Total:
              </td>
              <td style={{ padding: "10px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700, fontSize: 14 }}>
                {formatCurrency(total)}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}

CargosTab.propTypes = { data: PropTypes.object }

export default CargosTab
